import { useEffect, useState } from 'react';
import { getUserDetailsByIds } from '../../services/userServices';

// Nome e cognome di chi ha visualizzato, indicizzati per id utente.
const useViewerDetails = (views) => {
    const [details, setDetails] = useState({});

    useEffect(() => {
        const userIds = [...new Set((views || [])
            .filter((view) => view && view.user_id !== undefined)
            .map((view) => view.user_id))];
        if (userIds.length === 0) return;

        getUserDetailsByIds(userIds)
            .then((users) => setDetails(Object.fromEntries(users.map((user) => [user.id, user]))))
            .catch((error) => console.error('Errore nel recupero dei dettagli degli utenti:', error));
    }, [views]);

    return details;
};

export default useViewerDetails;
